









































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import store from '../../store';
import { DxButton, DxTextArea, DxRadioGroup, DxCheckBox, DxLookup } from 'devextreme-vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import CustomStore from 'devextreme/data/custom_store';
import CommonModule, { QuestelServicesClient } from '@questelservices/common';
import { Prop, Watch } from 'vue-property-decorator';
import { ManualCodeInvoiceLineItemNotesDto } from '@/models/ManualCodeInvoiceLineItemNotesDto';
import { AnalysisReportPrintDataOptionsType, AnalysisReportPrintDataOptionsTypeStrings } from '@/models/AnalysisReportPrintDataOptionsType';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxResponsiveBox, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
import { KeyMap } from '@/models/KeyMap';
import { FilingTypeDto } from '../../models/FilingTypeDto';
import { Popup } from '@questelservices/common-vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxSelectBox } from 'devextreme-vue/select-box';
import AutoTextDialog from "./auto-text-dialog.vue"
import { TextTemplateService } from '@/service/TextTemplateService';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import _ from "lodash";
import Html from '@/utilities/Html';
import * as overlay from 'devextreme/ui/overlay';

const commonState = getModule(CommonModule, store);

@Component({
  components: {
    DxButton,
    DxTextArea,
    DxRadioGroup,
    DxCheckBox,
    DxHtmlEditor,
    DxToolbar,
    DxItem,
    DxToolbarItem,
    DxResponsiveBox,
    DxLocation,
    DxCol,
    DxRow,
    Popup,
    DxLoadPanel,
    DxSelectBox,
    DxLookup,
    AutoTextDialog
  }
})
export default class PhaseAssignmentNotes extends Vue {    
$refs: Vue['$refs'] & {   
   privateNotesEditor?: DxHtmlEditor;
   auditorNotesEditor?: DxHtmlEditor;
   printOptionsRadio?: DxRadioGroup;
   markImportant?: DxCheckBox;
   printComments?: DxCheckBox;
   includeCharges?: DxCheckBox;   
} = {};

  @Prop({ default: false })
  showNotes!: boolean;

  @Prop()  
  lineItemId!: string;

  @Prop()
  filingType!: FilingTypeDto;

  @Prop({ default: false })
  loadingAutoTextData!: boolean;

  client: QuestelServicesClient;

  selectedText: Guid = '';
  notes: string = "";  
  openAutoText: boolean = false;

  get showingNotes() {
      return this.showNotes;
  }

  set showingNotes(value) {
      this.$emit("hiding");
  }

  screen(width: number) {
    if(width < 640)
      return 'xs';
    else 
      return 'sm';
  }
  
  value: string = this.lineItemId;
  notesLoaded: boolean = false;  
  reportLanguageInitialized: boolean = false;
  private printOptionsStrings: string[] = [
      'Do Not Print',
      'Single Line Item Only',
      'Entire Phase Data',
      'Entire Case Data'
    ];
  availableAutoText: Array<string> = [];
  
  privateNotes: string;
  auditorNotes: string;
  private selectedPrintOption: string = '';
  markImportant: boolean;
  printComments: boolean;
  includeCharges: boolean; 
  phaseHistory: string;

  selectedNotesItem: number = -1;
  selectedPrintItem: number = -1;
  textTemplateService: TextTemplateService;

  private get lineItemNotesUrl(): string {
    return `/api/manualcoding/${this.lineItemId}/lineItemNotes`;
  }

  private modifyNotesUrl: string = "/api/manualcoding/modifynotes";

  get reportLanguageLabel(): string {
    return `Report Language${this.isNonPatentFilingType ? ` (${this.filingType.Name})` : ''}`;
  }

  get isNonPatentFilingType() {
    return this.filingType != null && (this.filingType.FilingTypeId == null || this.filingType.FilingTypeId !== 0);
  }

  get privateNotesInstance() {
    return (this.$refs.privateNotesEditor as any).instance as any;
  }
  get auditorNotesInstance() {
    return (this.$refs.auditorNotesEditor as any).instance as any;
  }

  get auditorNotesData(): string {
    return this.auditorNotes;
  }

  get privateNotesData(): string {
    return this.privateNotes;
  }

  @Watch("showNotes")
  private async onPropertyChanged(value: boolean, oldValue: boolean) {    
    if (value) {     
      await this.loadNotes();
    }
  }

  created() {
    document.addEventListener('keyup', this.onKeyup);
  }

  destroyed() {
    document.removeEventListener('keyup', this.onKeyup);
  }

  onKeyup(event: KeyboardEvent) {
    switch (event.keyCode) {
      case KeyMap.tab:
        this.cycleNotesItem();
        break;
      case KeyMap.upArrow:
        this.cyclePrintOption(-1);
        break;
      case KeyMap.downArrow:
        this.cyclePrintOption(1);
        break;
    }
  }

  constructor() {    
    super();         
    this.client = new QuestelServicesClient(this.$store, '');
    this.notesLoaded = false;  

    this.textTemplateService = new TextTemplateService();
    this.privateNotes = "";
    this.auditorNotes = "";    
    this.markImportant = false;
    this.printComments = false;
    this.includeCharges = false;    
    this.phaseHistory = "";
    
    this.textTemplateStore = this.defaultTextStore();       
    overlay.baseZIndex(1500); 
  }

  private onReportLanguageChanged(e: any): void {
    // if no change then just exit function
    if(e.value === null && e.previousValue === '') {
      return;
    }    

    // If option is 'Do Not Print' then you type into report Language
    // change option to 'Enthire Phase Data'. Don't let blanks/spaces
    // trigger change
    var auditorTrim = Html.removeTags(e.value).trim();
    if(auditorTrim.length > 0 
      && this.selectedPrintOption === AnalysisReportPrintDataOptionsTypeStrings.DoNotPrint
      && this.reportLanguageInitialized) {      
      this.selectedPrintOption = AnalysisReportPrintDataOptionsTypeStrings.EntirePhase;
    }

    this.reportLanguageInitialized = true;
  }

  private onReportLanguageFocusOut(e: any): void {
    // If option is other than 'Do Not Print' and no data in
    // report language, then change option to 'Do Not Print'
    var auditorTrim = Html.removeTags(this.auditorNotesData).trim();
    if(auditorTrim.length === 0
        && this.selectedPrintOption !== AnalysisReportPrintDataOptionsTypeStrings.DoNotPrint) {      
      this.selectedPrintOption = AnalysisReportPrintDataOptionsTypeStrings.DoNotPrint;
    }
  }

  onSelectionChanged(e:any) {
    if(e.selectedItem) {
      let text =e.selectedItem.Text;
      let autoTextContained : string[] = [];

      this.availableAutoText.forEach(item => {
        if(_.includes(text, item)) {
          autoTextContained.push(item);
        }
      });
      
      this.$emit('process-auto-text', autoTextContained, text, (result : string) => {
        this.auditorNotes = result;
      });
    }
    
  }
  onNewEditAutoText(e:any) {
    this.openAutoText = true;
  }

  onAutoTextHiding(e:any){
    this.openAutoText = false;
    this.textTemplateStore = this.defaultTextStore();
  }

  private onNotesHidden(e: any) {
    this.selectedNotesItem = -1;
    this.auditorNotesInstance.reset();
    this.auditorNotesInstance.clearHistory();
    this.privateNotesInstance.reset();
    this.privateNotesInstance.clearHistory();
    this.selectedText = "";
  }

  private async loadNotes() {        
    const result = await this.client.getJson(this.lineItemNotesUrl);

    if(!result.Data) {
      throw result;
    }
    
    this.privateNotes = result.Data.PrivateAuditorNotes;
    this.auditorNotes = result.Data.AuditorNotesReportLanguage;
    this.reportLanguageInitialized = this.auditorNotes === '' ? true : false;
    this.selectedPrintOption = this.printOptionsStrings[result.Data.AnalysisReportPrintDataOptionsType];
    this.selectedPrintItem = result.Data.AnalysisReportPrintDataOptionsType;    

    this.markImportant = result.Data.MarkImportant;
    this.printComments = result.Data.PrintCommentsAuditorReport;
    this.includeCharges = result.Data.IncludeAllAgentsCharges;
    this.phaseHistory = result.Data.PhaseHistory;  
    this.notesLoaded = true;          
  }

  private saveNotes() {    
    let invoiceLineItemNotesDto = new ManualCodeInvoiceLineItemNotesDto();
    invoiceLineItemNotesDto.InvoiceLineItemId = this.lineItemId;
    
    invoiceLineItemNotesDto.PrivateAuditorNotes = this.privateNotesData;
    invoiceLineItemNotesDto.AuditorNotesReportLanguage = this.auditorNotesData;
    
    switch (this.selectedPrintOption) {
      case AnalysisReportPrintDataOptionsTypeStrings.DoNotPrint:
        invoiceLineItemNotesDto.AnalysisReportPrintDataOptionsType = AnalysisReportPrintDataOptionsType.DoNotPrint;
        break;
      case AnalysisReportPrintDataOptionsTypeStrings.SingleLineItem:
        invoiceLineItemNotesDto.AnalysisReportPrintDataOptionsType = AnalysisReportPrintDataOptionsType.SingleLineItem;
        break;
      case AnalysisReportPrintDataOptionsTypeStrings.EntirePhase:
        invoiceLineItemNotesDto.AnalysisReportPrintDataOptionsType = AnalysisReportPrintDataOptionsType.EntirePhase;
        break;
      case AnalysisReportPrintDataOptionsTypeStrings.EntireCase:
        invoiceLineItemNotesDto.AnalysisReportPrintDataOptionsType = AnalysisReportPrintDataOptionsType.EntireCase;
        break;
    }

    invoiceLineItemNotesDto.MarkImportant = this.markImportant;
    invoiceLineItemNotesDto.PrintCommentsAuditorReport = this.printComments;
    invoiceLineItemNotesDto.IncludeAllAgentsCharges = this.includeCharges;
    invoiceLineItemNotesDto.PhaseHistory = this.phaseHistory;       
    
    this.client.postJson(this.modifyNotesUrl, invoiceLineItemNotesDto).then(x=>{
      this.$root.$emit('updatenavmatters', null);
    });

    this.hidingNotes();
  }

  hidingNotes() {
    this.selectedNotesItem = -1;
    this.showingNotes = false;
    this.selectedText = '';
  }

  textTemplateStore: CustomStore ;
  
  defaultTextStore() {
    return new CustomStore({
        loadMode: 'raw',
        load: (options): Promise<any> => {
        return this.textTemplateService.getTextTemplate(TextTemplateTypeEnum.AutoText)
            .then((results : any) => {
                return results;
            }
            
            )
            .catch(err=> []);
        }
    });
  }

  cycleNotesItem() {    
    switch(this.selectedNotesItem) {
      case -1:        
        this.privateNotesInstance.setSelection(0,0);
        this.selectedNotesItem = 0;              
        break;

      case 0:    
        this.privateNotesInstance.undo();
        this.auditorNotesInstance.setSelection(0,0);
        this.selectedNotesItem = 1;        
        break;

      case 1:        
        this.auditorNotesInstance.undo();                            
        (this.$refs.printOptionsRadio as any).instance.focus();
        this.selectedNotesItem = 2;             
        break;      
    }       
  }

  cyclePrintOption(value: number) {    
    this.selectedPrintItem += value;    

    if(this.selectedPrintItem < 0) {
      this.selectedPrintItem = 0;
    }

    if(this.selectedPrintItem > 6) {
      this.selectedPrintItem = 6;
    }    

    switch(this.selectedPrintItem) {      
      case 3:        
        if(value == -1) {       
          if(this.$refs.auditorNotesEditor) {            
            (this.$refs.printOptionsRadio as any).instance.focus();                
          }           
          this.selectedPrintItem = 0;
        }
        break;        
      case 4:
        if(this.$refs.markImportant) {
          (this.$refs.markImportant as any).instance.focus();
        }                
        break;
      case 5:    
        if(this.$refs.printComments) {
          (this.$refs.printComments as any).instance.focus();              
        }           
        break;
      case 6:
        if(this.$refs.includeCharges) {
          (this.$refs.includeCharges as any).instance.focus();                
        }                
        break;
    }
  } 

  async mounted() {    
    this.availableAutoText = await this.textTemplateService.getAvailableAutoText(TextTemplateTypeEnum.AutoText);
  }  
}
